import React from 'react'

import { useMediaQuery } from "@mui/material";

import DetailsList from "../DetailsList/DetailsList";
import { Sidebar } from 'features/CoverageSidebar';

interface Props {
	onSubmit: () => void
	loading: boolean
}

const RentersForm = (props: Props) => {
	const {onSubmit, loading} = props;
	const matchesSM = useMediaQuery('(max-width:900px)');

	return (
		<div>
			<form>
				<DetailsList onSubmit={onSubmit} loading={loading}/>
				{/*<Liability/>*/}
				{/*<BelongingsSlider/>*/}
				{/*<AdditionalProtection/>*/}
				{/*<Deductible/>*/}
				{matchesSM && <Sidebar onSubmit={onSubmit} loading={loading}/>}
			</form>
		</div>
	)
}

export default RentersForm
